import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'fileInput', 'audioInput', 'preview', 'previewImage']

  connect () {
    this._previewUrl = null
    this._onCameraCaptured = () => { this.syncPreview() }
    this.element.addEventListener('chat-camera:captured', this._onCameraCaptured)

    if (this.hasFileInputTarget) {
      this.fileInputTarget.addEventListener('change', () => { this.syncPreview() })
    }
  }

  disconnect () {
    this.element.removeEventListener('chat-camera:captured', this._onCameraCaptured)
    this.revokePreviewUrl()
  }

  keydown (event) {
    if (event.key !== 'Enter' || event.shiftKey) return

    event.preventDefault()

    const body = this.inputTarget.value.trim()
    const hasFile = this.hasFileInputTarget && this.fileInputTarget.files?.length > 0
    const hasAudio = this.hasAudioInputTarget && this.audioInputTarget.files?.length > 0

    if (!body && !hasFile && !hasAudio) return

    this.element.requestSubmit()
  }

  clearAttachment (event) {
    event.preventDefault()

    if (this.hasFileInputTarget) {
      this.fileInputTarget.value = ''
    }

    this.hidePreview()
  }

  syncPreview () {
    const file = this.hasFileInputTarget ? this.fileInputTarget.files?.[0] : null

    if (!file) {
      this.hidePreview()
      return
    }

    this.revokePreviewUrl()
    this._previewUrl = URL.createObjectURL(file)

    if (this.hasPreviewImageTarget) {
      this.previewImageTarget.src = this._previewUrl
      this.previewImageTarget.alt = 'Photo ready to send'
    }

    if (this.hasPreviewTarget) {
      this.previewTarget.classList.remove('hidden')
    }
  }

  hidePreview () {
    this.revokePreviewUrl()

    if (this.hasPreviewImageTarget) {
      this.previewImageTarget.removeAttribute('src')
      this.previewImageTarget.alt = ''
    }

    if (this.hasPreviewTarget) {
      this.previewTarget.classList.add('hidden')
    }
  }

  revokePreviewUrl () {
    if (!this._previewUrl) return

    URL.revokeObjectURL(this._previewUrl)
    this._previewUrl = null
  }
}
